import React, { useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

const DateRangePicker = ({ onDateChange }) => {
    const datePickerRef = useRef(null);

    useEffect(() => {
        // Inicializar flatpickr con el modo de rango
        flatpickr(datePickerRef.current, {
            mode: "range",
            dateFormat: "d/m/y",
            disableMobile: true,
            position: "below",
            onChange: (selectedDates) => {
                // Cuando el rango de fechas cambia, pasarlo al componente padre
                if (selectedDates.length === 2) {
                    const [start, end] = selectedDates;
                    onDateChange({ start, end });  // Pasar las fechas al padre
                }
            }
        });
    }, [onDateChange]);

    return (
            <input 
                className="form-control datetimepicker"
                id="timepicker3"
                type="text"
                placeholder="dd/mm/yy a dd/mm/yy"
                ref={datePickerRef} 
                required />
        
    );
};

export default DateRangePicker;